var React = require('react');

function ButtonLoading (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M50 15A35 35 0 1 0 74.74873734152916 25.251262658470843","fill":"none","stroke":"#000000","strokeWidth":"12","key":0}),React.createElement("path",{"d":"M49 3L49 27L61 15L49 3","fill":"#000000","key":1}),React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1s","values":"0 50 50;360 50 50","keyTimes":"0;1","key":2})]));
}

ButtonLoading.defaultProps = {"focusable":"false","viewBox":"0 0 100 100"};

module.exports = ButtonLoading;

ButtonLoading.default = ButtonLoading;
